import { useRef, useUnmountCleanup } from '../lib/teact/teact';

import usePreviousDeprecated from './usePreviousDeprecated';

// NOTE: @yy 同步 effect，用于在组件渲染时执行的 effect，依赖项发生变化时会重新执行，顺序敏感
export default function useSyncEffect<const T extends readonly any[]>(
  effect: (args: T | readonly []) => NoneToVoidFunction | void,
  dependencies: T,
) {
  const prevDeps = usePreviousDeprecated<T>(dependencies);
  const cleanupRef = useRef<NoneToVoidFunction>();

  if (!prevDeps || dependencies.some((d, i) => d !== prevDeps[i])) {
    cleanupRef.current?.();
    cleanupRef.current = effect(prevDeps || []) ?? undefined;
  }

  useUnmountCleanup(() => {
    cleanupRef.current?.();
  });
}
